import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import OverviewLoader from "./AdminReporting/views/OverviewLoader/OverviewLoader";
import ScreenLoader from "./ScreenLoader";

const App1 = lazy(() => import("./AdminReporting/App1"));
const App = lazy(() => import("./AdOrchAdmin/App"));

const productionUrl = "hcs-adorch-admin.ecs.mmt";
// const ReportingProd = "advertising.makemytrip.com";
// const goibiboProd = "advertising.goibibo.com";

const isQA = window.location.hostname === "10.212.33.96";
const loadAdmin = isQA || window.location.hostname === productionUrl;

const componentToRender = loadAdmin || isQA ? <App /> : <App1 />;

ReactDOM.render(
	<React.StrictMode>
		<Suspense
			fallback={
				loadAdmin ? (
					<ScreenLoader mainText="Adtech Admin" lowerText="Loading ..." />
				) : (
					<OverviewLoader />
				)
			}
		>
			{componentToRender}
		</Suspense>
	</React.StrictMode>,
	document.getElementById("root")
);
